<template>
  <div>
      <div class="position">
        <div class="position__row">
          <ai-clear-button @click="setPosition('top')" class="position__button" :class="{'position__button--active': shadowParams.position === 'top'}">
            <inline-svg :src="require('@/assets/icons/shadow/position/top-position.svg')" />
          </ai-clear-button>
        </div>
        <div class="position__row">
          <ai-clear-button @click="setPosition('left')" class="position__button" :class="{'position__button--active': shadowParams.position === 'left'}">
            <inline-svg :src="require('@/assets/icons/shadow/position/left-position.svg')" />
          </ai-clear-button>
          <ai-clear-button @click="setPosition('center')" class="position__button" :class="{'position__button--active': shadowParams.position === 'center'}">
            <inline-svg :src="require('@/assets/icons/shadow/position/center-position.svg')" />
          </ai-clear-button>
          <ai-clear-button @click="setPosition('right')" class="position__button" :class="{'position__button--active': shadowParams.position === 'right'}">
            <inline-svg :src="require('@/assets/icons/shadow/position/right-position.svg')" />
          </ai-clear-button>
        </div>
        <div class="position__row">
          <ai-clear-button @click="setPosition('bottom')" class="position__button" :class="{'position__button--active': shadowParams.position === 'bottom'}">
            <inline-svg :src="require('@/assets/icons/shadow/position/bottom-position.svg')" />
          </ai-clear-button>
        </div>
      </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useServicesStore } from '@/store/services';
import { TPosition } from '@/types/shadow/TPosition';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

const { shadowParams } = storeToRefs(useServicesStore());

const setPosition = (position: TPosition): void => {
  shadowParams.value.position = position;
};

</script>

<style scoped lang="scss" src="./PositionList.scss" />
